import * as yup from 'yup';

export const schema = yup
  .string()
  .max(30, 'Please rename the file so it has a maximum of 30 characters')
  .required();
